// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FulfillmentManifestProperty } from '@/audit/api/types';
import { AuditOrderManifestLabel } from '@/audit/components/audit-order-manifest-label';

interface Props {
  property: FulfillmentManifestProperty;
}

/**
 * Renders a fulfillment order's line-item manifest as an old→new diff. Authored
 * manifests carry the requested quantity; a shipment-cascade sync also carries the
 * pending, shipped, and delivered tiers, so those appear when a shipment moved them.
 */
export function AuditFulfillmentManifestLabel(props: Props) {
  return (
    <AuditOrderManifestLabel
      name={props.property.name}
      oldValue={props.property.oldValue}
      newValue={props.property.newValue}
      tiers={(oldEntry, newEntry) => [
        {
          label: 'Requested',
          old: oldEntry.requestedQuantity,
          new: newEntry.requestedQuantity,
        },
        {
          label: 'Pending',
          old: oldEntry.pendingQuantity ?? null,
          new: newEntry.pendingQuantity ?? null,
        },
        {
          label: 'Quarantined',
          old: oldEntry.quarantinedQuantity ?? null,
          new: newEntry.quarantinedQuantity ?? null,
        },
        {
          label: 'Shipped',
          old: oldEntry.shippedQuantity ?? null,
          new: newEntry.shippedQuantity ?? null,
        },
        {
          label: 'Delivered',
          old: oldEntry.deliveredQuantity ?? null,
          new: newEntry.deliveredQuantity ?? null,
        },
      ]}
    />
  );
}
